var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":function($event){return _vm.$emit('toggle', _vm.name, !_vm.value)}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.title))])],1),_c('v-list-item-action',[_c('v-icon',{attrs:{"color":_vm.color,"small":""}},[_vm._v(_vm._s(_vm.icon))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }